import { registerLicense, L10n, loadCldr } from '@syncfusion/ej2-base'

loadCldr(
  require('@/libs/cldr-data/supplemental/numberingSystems.json'),
  require('@/libs/cldr-data/main/pl/ca-gregorian.json'),
  require('@/libs/cldr-data/main/pl/numbers.json'),
  require('@/libs/cldr-data/main/pl/timeZoneNames.json'),
)

if (process.env.VUE_APP_SYNCFUSION_LICENSE) {
  registerLicense(process.env.VUE_APP_SYNCFUSION_LICENSE)
}

L10n.load({
  pl: {
    schedule: {
      day: 'Dzień',
      week: 'Tydzień',
      workWeek: 'Tydzień roboczy',
      month: 'Miesiąc',
      agenda: 'Agenda',
      today: 'Dziś',
      noEvents: 'Brak zleceń',
      allDay: 'Cały dzień',
      start: 'Początek',
      end: 'Koniec',
      more: 'więcej',
      close: 'Zamknij',
      cancel: 'Anuluj',
      delete: 'Usuń',
      save: 'Zapisz',
      newEvent: 'Nowe zlecenie',
      editEvent: 'Edytuj zlecenie',
      deleteEvent: 'Usuń zlecenie',
      editContent: 'Czy chcesz edytować to zdarzenie?',
      deleteContent: 'Czy na pewno chcesz usunąć to zdarzenie?',
      deleteMultipleContent: 'Czy na pewno chcesz usunąć wybrane zdarzenia?',
      selected: 'wybrany',
      title: 'Tytuł',
      addTitle: 'Dodaj tytuł',
      moreDetails: 'Więcej szczegółów',
      previous: 'Poprzedni',
      next: 'Następny',
      textView: 'Widok tekstowy',
      timelineDay: 'Oś czasu — dzień',
      timelineWeek: 'Oś czasu — tydzień',
      timelineWorkWeek: 'Oś czasu — tydzień roboczy',
      timelineMonth: 'Oś czasu — miesiąc',
      timelineYear: 'Oś czasu — rok',
    },
  },
})

export default L10n
